module.exports = __webpack_public_path__ + "img/biggifttitle.3f868e03.png";